var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 7.00065C2.33333 8.63398 3.50667 9.98065 5.05333 10.274L4.06 9.28065L5 8.33398L7.66667 11.0073L5 13.6673L4.06 12.7273L5.11333 11.674V11.634C2.8 11.3607 1 9.38732 1 7.00065C1 4.42065 3.08667 2.33398 5.66667 2.33398H7.66667V3.66732H5.66667C3.82667 3.66732 2.33333 5.16065 2.33333 7.00065Z",
    fill: "#2F736E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.00065V2.33398H9V7.00065H15ZM13.6667 5.66732H10.3333V3.66732H13.6667V5.66732Z",
    fill: "#2F736E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33398H9V13.0007H15V8.33398Z",
    fill: "#2F736E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDown);
export default __webpack_public_path__ + "static/media/copy-down.c9126a54b457a1694e57c621cd0773ba.svg";
export { ForwardRef as ReactComponent };